<template>
	<section class="block-advantages advantages container_wide">
		<section
			class="advantages__advantage"
			v-for="(item, i) in data"
			:key="`item-${i}`"
			@click="getCall({ type: 'sale', text: `${item.title} ${item.subtitle}` })"
		>
			<div class="advantages__circle"></div>
			<div class="advantages__icon-wrapper">
				<img class="advantages__icon" :class="`advantages__icon_${i+1}`" :src="item.icon" alt="" />
			</div>
			<div class="advantages__text-wrapper">
				<h3 class="advantages__title" v-html="item.title"></h3>
				<h4 class="advantages__subtitle" v-html="item.subtitle"></h4>
			</div>
		</section>
	</section>
</template>

<script>
import Mixin from '../common/mixin';

// icons
import likeIcon from "../images/icons/like.svg";
import creditIcon from "../images/icons/credit.svg";
import shieldIcon from "../images/icons/shield.svg";
import carIcon from "../images/icons/car.svg";


export default {
	name: "block-advantages",
	mixins: [Mixin],
	data() {
		return {
			data: [
				{
					title: "Особые условия",
					subtitle: "для корпоративных клиентов",
					icon: likeIcon,
				},
				/* {
					title: "Выгодный кредит 0.01%",
					subtitle: "Более 90% одобрений по кредиту",
					icon: creditIcon,
				},
        {
					title: "Рассрочка 0%",
					subtitle: "",
					icon: carIcon,
				}, */
				{
					title: "5 лет поддержки",
					subtitle: "полное гарантийное обслуживание от оф. дилера",
					icon: shieldIcon,
				},
				// {
				// 	title: "Кредит*",
				// 	subtitle: "",
				// 	icon: creditIcon,
				// },
				{
					title: "Рассрочка*",
					subtitle: "Получите уникальное предложение",
					icon: creditIcon,
				},
				{
					title: "Без наценки дилера!",
					subtitle: "Персональные предложения <nobr>от директора</nobr>",
					icon: carIcon,
				},
			],
		}
	},
}
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.advantages {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
  gap: 20px;
	width: 100%;
  // max-width: 750px;
	padding: 40px 10px 0;
	margin-bottom: 100px;

	&__advantage {
		position: relative;
		max-width: 300px;
		height: 120px;
		padding-left: 20px;
		cursor: pointer;
		flex: 1;
	}

	&__circle {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		z-index: 1;
		width: 110px;
		height: 110px;
		background-color: #DDDDDD;
		border-radius: 50%;
	}

	&__text-wrapper {
		position: relative;
		z-index: 2;
		margin-top: 6px;
	}

	&__icon-wrapper {
		width: 50px;
		height: 40px;
	}

	&__icon {
		position: relative;
		z-index: 2;

		&_1 {
			top: -10px;
			width: 37.96px;
		}

		&_2 {
			//width: 46px;
      width: 31.3px;
		}

		/* &_4 {
			top: -5px;
			width: 31.3px;
		}

		&_3 {
			width: 41.91px;
		} */
	}

	&__title,
	&__subtitle {
		text-transform: uppercase;
	}

	&__title {
		font-size: 14px;
		font-weight: 600;
	}

	&__subtitle {
		font-size: 14px;
		font-weight: 400;
	}
}

@media (max-width: 790px) {
	.advantages {
    // display: grid;
    // grid-template-columns: repeat(2, 1fr);
    // justify-items: center;
		gap: 10px;
		justify-content: center;

		&__advantage {
			width: 48%;
			height: 110px;
			margin-bottom: 10px;
			margin-top: 10px;
		}
	}
}

@media (max-width: 540px) {
	.advantages {
		&__advantage:last-child &__title {
			hyphens: manual;
		}

		&__title, &__subtitle {
			font-size: 12px;
		}
	}
}
</style>
